/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RangeQueryValue } from './RangeQueryValue';
import {
    RangeQueryValueFromJSON,
    RangeQueryValueFromJSONTyped,
    RangeQueryValueToJSON,
    RangeQueryValueToJSONTyped,
} from './RangeQueryValue';
import type { RegexpQueryValue } from './RegexpQueryValue';
import {
    RegexpQueryValueFromJSON,
    RegexpQueryValueFromJSONTyped,
    RegexpQueryValueToJSON,
    RegexpQueryValueToJSONTyped,
} from './RegexpQueryValue';
import type { SizeQueryValue } from './SizeQueryValue';
import {
    SizeQueryValueFromJSON,
    SizeQueryValueFromJSONTyped,
    SizeQueryValueToJSON,
    SizeQueryValueToJSONTyped,
} from './SizeQueryValue';
import type { InQueryItem } from './InQueryItem';
import {
    InQueryItemFromJSON,
    InQueryItemFromJSONTyped,
    InQueryItemToJSON,
    InQueryItemToJSONTyped,
} from './InQueryItem';
import type { EqualsQueryValue } from './EqualsQueryValue';
import {
    EqualsQueryValueFromJSON,
    EqualsQueryValueFromJSONTyped,
    EqualsQueryValueToJSON,
    EqualsQueryValueToJSONTyped,
} from './EqualsQueryValue';
import type { QueryExpression } from './QueryExpression';
import {
    QueryExpressionFromJSON,
    QueryExpressionFromJSONTyped,
    QueryExpressionToJSON,
    QueryExpressionToJSONTyped,
} from './QueryExpression';

/**
 * Logical NOT (negation) of a condition.
 * "Not equals" does not apply on null values. To match non-equal including nulls, combine with an ExistsQuery.
 * 
 * @export
 * @interface NotQuery
 */
export interface NotQuery {
    /**
     * Direct field value matching.
     * 
     * Values can include `null` and/or `""`.
     * 
     * @type {{ [key: string]: EqualsQueryValue; }}
     * @memberof NotQuery
     */
    equals?: { [key: string]: EqualsQueryValue; };
    /**
     * Logical AND combination of conditions.
     * @type {Array<QueryExpression>}
     * @memberof NotQuery
     */
    and?: Array<QueryExpression>;
    /**
     * Logical OR combination of conditions
     * @type {Array<QueryExpression>}
     * @memberof NotQuery
     */
    or?: Array<QueryExpression>;
    /**
     * 
     * @type {NotQuery}
     * @memberof NotQuery
     */
    not?: NotQuery;
    /**
     * Value list matching (field IN list).
     * 
     * Values can include `null` and/or `""`.
     * 
     * @type {{ [key: string]: Array<InQueryItem>; }}
     * @memberof NotQuery
     */
    in?: { [key: string]: Array<InQueryItem>; };
    /**
     * Range queries for numeric, date, or string fields.
     * @type {{ [key: string]: RangeQueryValue; }}
     * @memberof NotQuery
     */
    range?: { [key: string]: RangeQueryValue; };
    /**
     * Field existence check (field path).
     * @type {string}
     * @memberof NotQuery
     */
    exists?: string;
    /**
     * Collection/array size check.
     * @type {{ [key: string]: SizeQueryValue; }}
     * @memberof NotQuery
     */
    size?: { [key: string]: SizeQueryValue; };
    /**
     * Containment search for objects or arrays.
     * 
     * **Event Search:**
     * The `match` operator also supports searching Logistics Objects by their associated events using the path `{entity}.events`.
     * This is the **ONLY** operator that can be used to search event fields.
     * 
     * Example - search by event:
     * ```json
     * {
     *   "match": {
     *     "lo.events": {
     *       "code": "DELIVERED",
     *       "domain": "BUSINESS"
     *     }
     *   }
     * }
     * ```
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof NotQuery
     */
    match?: { [key: string]: { [key: string]: any; }; };
    /**
     * Regular expression matching.
     * @type {{ [key: string]: RegexpQueryValue; }}
     * @memberof NotQuery
     */
    regexp?: { [key: string]: RegexpQueryValue; };
}

/**
 * Check if a given object implements the NotQuery interface.
 */
export function instanceOfNotQuery(value: object): value is NotQuery {
    return true;
}

export function NotQueryFromJSON(json: any): NotQuery {
    return NotQueryFromJSONTyped(json, false);
}

export function NotQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'equals': json['equals'] == null ? undefined : (mapValues(json['equals'], EqualsQueryValueFromJSON)),
        'and': json['and'] == null ? undefined : ((json['and'] as Array<any>).map(QueryExpressionFromJSON)),
        'or': json['or'] == null ? undefined : ((json['or'] as Array<any>).map(QueryExpressionFromJSON)),
        'not': json['not'] == null ? undefined : NotQueryFromJSON(json['not']),
        'in': json['in'] == null ? undefined : json['in'],
        'range': json['range'] == null ? undefined : (mapValues(json['range'], RangeQueryValueFromJSON)),
        'exists': json['exists'] == null ? undefined : json['exists'],
        'size': json['size'] == null ? undefined : (mapValues(json['size'], SizeQueryValueFromJSON)),
        'match': json['match'] == null ? undefined : json['match'],
        'regexp': json['regexp'] == null ? undefined : (mapValues(json['regexp'], RegexpQueryValueFromJSON)),
    };
}

export function NotQueryToJSON(json: any): NotQuery {
    return NotQueryToJSONTyped(json, false);
}

export function NotQueryToJSONTyped(value?: NotQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'equals': value['equals'] == null ? undefined : (mapValues(value['equals'], EqualsQueryValueToJSON)),
        'and': value['and'] == null ? undefined : ((value['and'] as Array<any>).map(QueryExpressionToJSON)),
        'or': value['or'] == null ? undefined : ((value['or'] as Array<any>).map(QueryExpressionToJSON)),
        'not': NotQueryToJSON(value['not']),
        'in': value['in'],
        'range': value['range'] == null ? undefined : (mapValues(value['range'], RangeQueryValueToJSON)),
        'exists': value['exists'],
        'size': value['size'] == null ? undefined : (mapValues(value['size'], SizeQueryValueToJSON)),
        'match': value['match'],
        'regexp': value['regexp'] == null ? undefined : (mapValues(value['regexp'], RegexpQueryValueToJSON)),
    };
}

